import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=d212061a&lang=pug&"
import script from "./accounts.vue?vue&type=script&lang=js&"
export * from "./accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./accounts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports